<template>
    <div class="widget">
        <div class="panel">
            <div class="panel-heading">
                <span class="badge" v-if="checkins && checkins.length > 0">{{checkins.length}}</span>
                <h2>Course Alerts<i class="clippie fa fa-info-circle" v-tooltip="'Find your time sensitive course alerts below'"></i></h2>
                <div class="toggle-widget" @click="open=!open">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open">
                <ul v-if="checkins && checkins.length > 0" class="class-alerts clearfix path-alert">
                    <li v-for="checkin in checkins" v-if="isFirstInWeek(checkin)">
                        <router-link :to="{name: 'mentorCheckins', query: {id: checkin.id}}">
                            <img src="./../../assets/img/bullhorn.png">
                            <div class="alert-text">
                                <span class="alert-name">Check-in for Week {{checkin.week}}</span>
                                <br>{{checkin.dueDate | checkinDate}}<br>
                                <span class="overdue" v-if="isOverdue(checkin.dueDate)">Overdue</span>
                                <countdown v-else :date="checkin.dueDate" :fast="true"></countdown>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import checkins from '../../services/checkins';

import Countdown from '../reusable/countdown/CountdownTimer.vue';
import moment from 'moment';

export default {
    data() {
        return {
            checkins: null,
            open: true
        }
    },
    components: {
        Countdown
    },
    mounted() {
        this.getCheckins();

        this.$bus.$on('reloadCheckins', () => {
            this.getCheckins();
        });

        this.$bus.$on('checkin', (id) => {
            let exists = this.checkins.findIndex(function(e) { return e.id === id });

            if (exists > -1) {
                this.checkins.splice(exists, 1);
            }

        });
    },
    methods: {
        isFirstInWeek(checkin) {
            let firstCheckinInWeek = this.checkins.filter((c)=> { return c.week === checkin.week}).sort((a,b)=> { return new Date(a.startTime) - new Date(b.startTime)})[0];
            return firstCheckinInWeek.id === checkin.id;
        },
        getCheckins() {
            checkins.get().then((response) => {
                const now = new Date();
                if (response.checkins) {
                    this.checkins = response.checkins.filter((c) => {
                       if (new Date(c.startDate) < now && (!c.checkin || (c.numberOfStudents > c.checkin.weekly_evaluations.length))) return true;
                       if (c.meetingId && new Date(c.meetingTime) < now && (!c.checkin || (c.numberOfStudents > c.checkin.weekly_evaluations.length))) return true;
                       return false;
                        
                    });
                }

            });
        },
        isOverdue(d) {
            return new Date(d) < new Date();
        },
    },
    computed: {
        week() {
            return this.$store.getters.realCurrentWeek;
        }
    }
}

</script>
<style lang="scss" scoped>
.overdue {
    color: red;
}

.panel-body p {
    text-align: center;
    padding-top: 2rem;
}

.class-alerts {
    padding-bottom: 0rem;
}

.path-alert {
    padding-top: 0 !important;
    padding-bottom: 0rem;

}

.panel-body>ul:last-child {
    padding-bottom: 2rem;
}

a {
    color: inherit;
}

ul {
    clear: both;
    padding-bottom: 2rem;
    padding-top: 1.5rem;
}

li {
    padding: 1rem 1rem 1rem 2rem;
    clear: both;
}

h5 {
    margin-bottom: 0;
}

img,
.alert-text {
    display: block;
    float: left;
}

.alert-text {
    padding-left: 1rem;
    max-width: 80%;
}

.alert-name {
    color: white;
}

</style>



// WEBPACK FOOTER //
// MentorAlerts.vue?c22f506c